/*
 *
 * ----------------------------------------------- */

if ($(".home")) {
  var i = 0;

  function move() {
    if (i === 0) {
      i = 1;
      var elem = $("#loader .load-percent");
      var time = 1;
      var id = setInterval(frame, 10);
      function frame() {
        if (time >= 100) {
          clearInterval(id);
          i = 0;
          $("body").removeClass("loading");
          $("#loader").fadeOut("slow");
        } else {
          time++;
          elem.text(time);
        }
      }
    }
  }

  $(window).on("load", function () {
    move();
  });
}
